import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import partners from "../../../data/partner.json";

const PartnerLogos = () => {
  const getImageSrc = (imageName) => {
    try {
      return require(`../../../assets/images/partner/${imageName}`);
    } catch (e) {
      console.error(`Image not found: ${imageName}`);
      return '';
    }
  };

  return (
    // 'aria-label' hinzugefügt, um der Sektion einen Namen zu geben
    <section className="py-5 bg-light border-top border-bottom" aria-label="Unsere Kooperationspartner">
      <Container>
        {/* 'text-muted' durch 'text-secondary' ersetzt für besseren Kontrast */}
        <p className="text-center text-secondary small text-uppercase fw-bold mb-4" style={{ letterSpacing: "0.1em" }}>
          Starke Partner für deine Ausbildung
        </p>
        
        {/* 'opacity-75' entfernt oder reduziert, da dies den Text/Logo-Kontrast verschlechtert */}
        <Row className="justify-content-center align-items-center g-4">
          {partners.map((partner, index) => (
            <Col key={index} xs={6} md={3} className="text-center">
              <div 
                className="p-3 border rounded-3 bg-white shadow-sm d-flex align-items-center justify-content-center"
                // Filter 'grayscale' ist okay, aber 'brightness' sollte nicht zu hoch sein
                style={{ height: "80px", filter: "grayscale(100%) contrast(0.8)" }}
              >
                <img 
                  src={getImageSrc(partner.image)} 
                  // WICHTIG: Präziser Alt-Text für Screenreader
                  alt={`Logo vom Partnerunternehmen ${partner.name}`} 
                  className="img-fluid" 
                  style={{ maxHeight: "60px", maxWidth: "100%" }} 
                  // 'loading="lazy"' verbessert zusätzlich den Performance-Score
                  loading="lazy"
                />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default PartnerLogos;